import { useState, useEffect, useRef } from 'react';
import cookie from 'react-cookies';
// 2022-11-18 因为cookie爆栈，替换cookie为localStorage

interface PropsComp {
    sec: number;
    onFinish?: any;
    isNeedBracket?: boolean;
    secUnit?: string;
}

/**
 * 秒倒计时器
 * @param sec {number}
 * @param onFinish {function}
 * @return { ReactNode }
 */
const CountDown = ({ sec, onFinish, isNeedBracket = true, secUnit }: PropsComp) => {
    const intervalRef = useRef<any>(0);
    const [count, setCount] = useState(0);
    const unit = secUnit !== undefined ? secUnit : 'S';

    useEffect(() => {
        const cdt = cookie.load('countdown_time');

        intervalRef.current = sec;
        setCount(intervalRef.current);

        if (cdt) {
            const timer_date = cdt.date;
            const now = +new Date();
            const isInRange = ~~((now - timer_date) / 1000) <= sec;

            if (isInRange) {
                intervalRef.current = cdt.sec;
                setCount(intervalRef.current);
            }
        }

        const timer = setInterval(() => {
            if (intervalRef.current < 1) {
                clearInterval(timer);
                cookie.remove('countdown_time');
                onFinish && onFinish();
            } else {
                intervalRef.current = intervalRef.current - 1;
                setCount(intervalRef.current);
                cookie.save(
                    'countdown_time',
                    {
                        date: +new Date(),
                        sec: intervalRef.current,
                    },
                    { path: '/' },
                );
            }
        }, 1000);

        return () => {
            clearInterval(timer);
            cookie.remove('countdown_time', { path: '/' });
        };
    }, [sec]);

    return <>{count > 0 && (isNeedBracket ? '(' + count + unit + ')' : `${count}${unit}`)}</>;
};

export default CountDown;
